// Environment configuration
// In production, these should be set in Vercel environment variables

export const config = {
  supabase: {
    url: import.meta.env.VITE_SUPABASE_URL || '',
    anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || '',
  },
  app: {
    name: 'NUTRY',
    version: '1.0.0',
    environment: import.meta.env.MODE,
  },
  api: {
    baseUrl: import.meta.env.VITE_API_URL || '/api',
  },
} as const;

// Validate required environment variables
export function validateConfig(): void {
  const required = [
    ['VITE_SUPABASE_URL', config.supabase.url],
    ['VITE_SUPABASE_ANON_KEY', config.supabase.anonKey],
  ];

  const missing = required.filter(([, value]) => !value);

  if (missing.length > 0 && import.meta.env.PROD) {
    console.error(
      'Missing required environment variables:',
      missing.map(([name]) => name).join(', ')
    );
  }
}
